import { render, staticRenderFns } from "./OpenImageModalButton.vue?vue&type=template&id=2f53c16f&"
import script from "./OpenImageModalButton.vue?vue&type=script&lang=ts&"
export * from "./OpenImageModalButton.vue?vue&type=script&lang=ts&"
import style0 from "./OpenImageModalButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports